export interface ILocalTargetingParsed {
  type: string;
  country: string;
  states: string;
  areStatesCommaSeparated?: boolean;
  cities: string;
  areCitiesCommaSeparated?: boolean;
  zips: string;
  dmas: string;
  areDMAsCommaSeparated?: boolean;
}
export interface ILocalTargetingUI {
  type: string;
  country: string;
  states: string;
  areStatesCommaSeparated?: boolean;
  cities: string;
  areCitiesCommaSeparated?: boolean;
  zips: string;
  dmas: string;
  areDMAsCommaSeparated?: boolean;
  reactKey: string | number;
}

export const defaultLocalTargetingUI: ILocalTargetingUI = {
  type: 'country',
  country: '',
  states: '',
  cities: '',
  zips: '',
  dmas: '',
  reactKey: 0,
};
